import React from 'react';
import { Field, RadioGroup, Checkbox } from '../../../Core';
import { ListFieldSection } from '../../../Layout';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import CwdChartSection from './CwdChartSection';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';

let CompactionCwdSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const enterConvertedWetDensity =
    useSelector(createWorksheetSelector!('Preparation.EnterConvertedWetDensity')) ?? false;

  return (
    <>
      <ListFieldSection>
        <Field
          input={<Checkbox />}
          label="Enter converted wet density data"
          name="Preparation.EnterConvertedWetDensity"
        />
        <Field
          input={<RadioGroup />}
          label="Wet Density Masses Entered In"
          name="Preparation.WetDensityMassEntryUnit"
          options={['Grams', 'Pounds'].map((e) => ({ label: e, value: e.toLowerCase() }))}
        />
      </ListFieldSection>
      {enterConvertedWetDensity && <CwdChartSection />}
    </>
  );
};

CompactionCwdSection = withInjectedProps(CompactionCwdSection);

export { CompactionCwdSection };
export default CompactionCwdSection;
